// extracted by mini-css-extract-plugin
export default {"modalBody":"modalBody-AGgi2","subHeader":"subHeader-msqOG","cards":"cards-ZMefP","closeIcon":"closeIcon-umQ8l"};